<template>
  <div class="asc-subscription-center-header--controls">
    <asc-accent-button
      button-text="Cancel"
      secondary
      :on-click="handleCancel"
      :disabled="cancelDisabled"
    ></asc-accent-button>
    <asc-accent-button
      button-text="Save"
      :on-click="handleSave"
      :loading="saveLoading"
      :disabled="saveDisabled"
    ></asc-accent-button>
    <asc-tooltip :key="1" left :tooltip="getTooltip" :tooltip-length="0">
      <asc-switch
        label="Active"
        :disabled="!activateEnabled"
        :class="[!activateEnabled ? 'disabled' : '']"
        :value="active"
        :hide-details="true"
        @input="handleToggleActivate"
      ></asc-switch>
    </asc-tooltip>
  </div>
</template>

<script>
import AscSwitch from '@/components/atoms/AscSwitch'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  name: 'AscSubscriptionCenterHeaderWrapper',

  components: {
    AscSwitch,
    AscAccentButton,
    AscTooltip,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    activateEnabled: {
      type: Boolean,
      default: false,
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getTooltip() {
      return !this.activateEnabled
        ? 'Fix all errors to activate custom alert.'
        : ''
    },
  },

  methods: {
    handleSave() {
      this.$emit('handleSave')
    },
    handleCancel() {
      this.$emit('handleCancel')
    },
    handleToggleActivate(value) {
      this.$emit('handleToggleActivate', value)
    },
  },
}
</script>

<style lang="scss">
.asc-subscription-center-header--controls {
  display: flex;
  justify-content: flex-end;

  .asc-accent-button-container {
    margin-top: 0;
    margin-right: 8px;
  }

  .asc-switch {
    margin-top: -6px;

    &.disabled {
      opacity: 0.3;
    }

    .asc-label {
      color: $gray-700;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
    }

    .v-label {
      width: 30px;
      color: $gray-800 !important;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;
    }
  }
}
</style>
